export default "__VITE_ASSET__w15QpBiE__"